<template>
  <div class="register-container">
    <h3 class="text-center">利用規約</h3>
    <div class="announce-container accept-license-container p-xs flexbox">
      <div class="flex-grow">
        <a :href="downloadUrl" @click="download" target="_blank" style="color: #333">
          <button type="button" class="btn btn-basic btn-block"><i class="fa fa-download" aria-hidden="true"></i> 利用規約を確認する </button>
        </a>
        <button type="button" class="btn btn-warning btn-block m-t-md" @click="acceptLicense">
          利用規約に同意する
        </button>
        <div v-if="showMessage" class="font-bold text-danger m-t-xs">※利用規約をご確認のうえ、同意してください</div>
      </div>
    </div>
  </div>
</template>
<script>
import AuthenticationService from '@/services/authenticationservice'
import msg from '@/common/msg'
import store from '@/store'
import Util from '@/common/utility'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  data () {
    return {
      loader: null,
      isDownload: false,
      showMessage: false,
      downloadUrl: `${process.env.NODE_DOMAIN}/static/dists/pdf/contract.pdf`
    }
  },
  methods: {
    download () {
      let logParams = {
        name: eventCode.terms_of_service.confirm,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      if (navigator.onLine) {
        this.isDownload = true
        this.showMessage = false
      } else {
        store.commit('toggleModal', {
          show: true,
          message: msg.noInternet
        })
      }
    },
    async acceptLicense () {
      if (!this.isDownload) {
        this.showMessage = true
        return
      }
      this.loader = this.$loading.show()
      let result = await AuthenticationService.acceptLicense()
      if (result) {
        store.commit('setStatus', '1')
        await Util.getSellerInfo()
        this.$router.push('/home')
      } else {
        store.commit('toggleModal', {
          show: true,
          message: msg.acceptLicenseErr
        })
      }
      this.loader && this.loader.hide()

      let logParams = {
        name: eventCode.terms_of_service.agree,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/AcceptLicense.vue